export default __webpack_public_path__ + "static/media/product-2.4c066971.jpg";